import React from 'react'
import { Loader } from '@web/walter-ui-kit'

import styles from './style.module.css'

export function Preloader() {
    return (
        <div className={styles.tab}>
            <div className={styles.profile}>
                <Loader isCircled width={72} height={72} />

                <div className={styles.info}>
                    <Loader width={150} height={20} />
                    <Loader width={200} height={17} />
                </div>
            </div>

            <div className={styles.userInfo}>
                <Loader width={60} height={14} />
                <div className={styles.clientId}>
                    <Loader width={130} height={18} />
                </div>
                <Loader width="100%" height={14} />
                <Loader width={200} height={14} />
            </div>
        </div>
    )
}
